import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ApplicationState } from "../../store";
import { useTranslation } from "react-i18next";

const LegalDocumentContainer = () => {
    const location = useLocation();
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const isFrenchOnlyPartner: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isFrenchOnlyPartner
            ? state.configurationState.configuration.partnerConfig.isFrenchOnlyPartner
            : false
    );
    const termsOfUseLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            : ""
    );
    const privacyPolicyLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            : ""
    );
    const isPartnerIdIsGoezshield = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 36
                ? true
                : false
            : false
    );
    const privacyPolicyLegalDocumentLabel = useSelector((state: ApplicationState) =>
        state.configurationState?.configuration?.partnerConfig?.privacyPolicyLegalDocumentLabel
    );
    const termsOfUseLegalDocumentLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel === "Terms of Use"
                ? tLang("pageFooter.termsOfUse")
                : state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            : tLang("pageFooter.termsOfUse")
    );
    const personalInformationLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.personalInformationLabel
            ? state.configurationState.configuration.partnerConfig.personalInformationLabel === "Personal Information We Collect"
                ? tLang("pageFooter.personalInfoWeCollect")
                : state.configurationState.configuration.partnerConfig.personalInformationLabel
            : tLang("pageFooter.personalInfoWeCollect")
    );
    const personalInformationLink: string = useSelector((state: ApplicationState) =>
        state.configurationState &&
        state.configurationState.configuration.partnerConfig.personalInformationLink
            ? state.configurationState.configuration.partnerConfig.personalInformationLink
            : isFrenchOnlyPartner
                ? "https://www.sontiq.com/fr/privacy-policy"
                : "https://www.sontiq.com/privacy-policy/#notice-at-collection"
    );
    const query = new URLSearchParams(location.search);
    const LookupType: any = query.get("Type");
    const isTypeSSOProvisional = LookupType === "SSO_PROVISIONAL";
    const getTermsOfUseURL = () => {
        const baseUrl = window.location.origin + "/app";
        let termsofUseUrl: string = `${baseUrl}/terms`;

        if (termsOfUseLegalDocumentLink) {
            termsofUseUrl = termsOfUseLegalDocumentLink.startsWith("/") ? baseUrl + termsOfUseLegalDocumentLink : termsOfUseLegalDocumentLink;
        }

        return termsofUseUrl;
    };

    const getPrivacyNoticeURL = () => {
        const baseUrl = window.location.origin + "/app";
        let privacyNoticeUrl: string = `${baseUrl}/privacy`;

        if (privacyPolicyLegalDocumentLink) {
            privacyNoticeUrl = privacyPolicyLegalDocumentLink.startsWith("/") ? baseUrl + privacyPolicyLegalDocumentLink : privacyPolicyLegalDocumentLink;
        }

        if (isPartnerIdIsGoezshield) {
            privacyNoticeUrl = "https://www.sontiq.com/privacy-policy/";
        }

        return privacyNoticeUrl;
    };

    // facing issues with Privacy Policy not translating the same from different environments so making this more fail proof
    const normalize = (value?: string) =>(value || "").replace(/\u00A0/g, " ").trim().toLowerCase();
    const isPrivacyNotice = (value?: string) => normalize(value) === "privacy notice";
    const getPrivacyNoticeLinkText = () => {
        if (isPartnerIdIsGoezshield || isTypeSSOProvisional) {
            return tLang("pageFooter.privacyNotice");
        }

        const label = privacyPolicyLegalDocumentLabel;

        if (isPrivacyNotice(label)) {
            return tLang("pageFooter.privacyNotice");
        }

        return tLang("pageFooter.privacyPolicy");
    };

    const getTermsOfUseLinkText = () => {
        if (isPartnerIdIsGoezshield) {
            return tLang("pageFooter.termsOfUse");
        }

        return termsOfUseLegalDocumentLabel;
    };

    const getPersonalInfoLinkText = () => {
        return personalInformationLabel;
    };

    return {
        getTermsOfUseURL,
        getPrivacyNoticeURL,
        getPrivacyNoticeLinkText,
        getTermsOfUseLinkText,
        getPersonalInfoLinkText,
        personalInformationLabel,
        personalInformationLink
    };
};

export default LegalDocumentContainer;
